enum IntentStepType {
  MESSAGE_BLOCK = 'MESSAGE_BLOCK',
  GO_TO_INTENT = 'GO_TO_INTENT',
  ELICIT_SLOT = 'ELICIT_SLOT',
  SEND_EMAIL = 'SEND_EMAIL',
  SEND_SMS = 'SEND_SMS',
  DELETE_VARIABLE = 'DELETE_VARIABLE',
  CONDITIONAL = 'CONDITIONAL',
  GENERATIVE_AI = 'GENERATIVE_AI',
  ARITHMETIC = 'ARITHMETIC',
  DATE = 'DATE',
  CODE_BLOCK = 'CODE_BLOCK',
  LLM = 'LLM',
  DO_NOTHING = 'DO_NOTHING'
}

export default IntentStepType;
